<template lang="pug">
  .msn
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
        .edit-select
          select.select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs.edit-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            .modal__row
              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Реквизиты")
                  template(slot="body")
                    e-form-group(
                      name="name"
                      inputType="input"
                      label="Идентификатор"
                      :model="fields"
                      :required="true"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="owner"
                      inputType="input"
                      label="Балансодержатель"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      v-if='hasMsnEpidemiologicalConclusion'
                      name="epidemiological_conclusion"
                      inputType="input"
                      label="СЭЗ"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      v-if='hasMsnDailyNorm'
                      name="daily_norm"
                      inputType="input"
                      label="Суточная норма накопления, тонн"
                      :model="fields"
                      validationRule="double"
                      tabView="tab1"
                    )
                    e-form-group(
                      v-if='hasMsnDailyNorm'
                      name="daily_norm_cub"
                      inputType="input"
                      label="Суточная норма накопления, куб. м."
                      :model="fields"
                      validationRule="double"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="containers_count"
                      inputType="input"
                      label="Количество контейнеров"
                      :model="fields"
                      validationRule="number"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      name="volume_count"
                      inputType="input"
                      label="Общий объем контейнерной площадки, куб. м."
                      :model="fields"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      name="section_presence_for_big_garbage"
                      inputType="input"
                      label="Секция для накопления крупногабаритных отходов, куб. м."
                      :model="fields"
                      validationRule="double"
                      tabView="tab1"
                    )
                    div(v-if="hasPlacesPeriodField" ).e-form-group.form-group
                      label.period-label Периодичность вызова
                      e-radio(
                        name="route_period_id"
                        :options="routePeriods"
                        :model="fields"
                        tabView="tab1"
                      ).radio-block
                    e-form-group(
                      name="is_temporarily"
                      inputType="checkbox"
                      caption="Площадка временного назначения"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="created_at"
                      inputType="input"
                      label="Дата внесения в реестр"
                      :model="fields"
                      tabView="tab1"
                      :disabled="true"
                    )
              .modal__col
                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="close_date"
                  inputType="calendar"
                  label="Дата закрытия"
                  :model="fields"
                  tabView="tab1"
                  type="date"
                  :disabled="fields.status_id !== notActive"
                )
                e-form-group(
                  v-if='hasMsnRoofType'
                  name="msn_container_area_roof_id"
                  inputType="select"
                  label="Вид площадки"
                  :model="fields"
                  tabView="tab1"
                  :options="roofTypes"
                )
                e-form-group(
                  v-if='hasMsnFenceType'
                  name="msn_container_area_fence_id"
                  inputType="select"
                  label="Тип ограждения"
                  :model="fields"
                  tabView="tab1"
                  :options="fenceTypes"
                )
                e-form-group(
                  v-if='hasMsnSurfaceType'
                  name="msn_container_area_floor_id"
                  inputType="select"
                  label="Тип подстилающей поверхности"
                  :model="fields"
                  tabView="tab1"
                  :options="underSurfaceTypes"
                )
                e-form-group(
                  name="is_separate"
                  inputType="select"
                  :required="true"
                  label="Наличие раздельного сбора"
                  :model="fields"
                  tabView="tab1"
                  :options="isSeparateTypes"
                )
                e-form-group(
                  v-if='hasMsnType'
                  name="msn_by_type_id"
                  inputType="select"
                  label="Тип контейнерной площадки"
                  :model="fields"
                  tabView="tab1"
                  :options="msnByTypes"
                )
                owner-block(
                  v-if='hasMemberChoose'
                  :owner='fields.owner_obj'
                  @deleteOwner='deleteOwner'
                  @setOwner='setOwner'
                )
              .modal__col
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab2"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )
                accordion
                  template(slot="header")
                    e-form-subtitle(text="Местоположение")
                  template(slot="body")
                    e-location(
                      :formValidator="formValidator"
                      :model="fields"
                      name="address"
                      :addressData="addressData"
                      tabView="tab1"
                    )

          // Характеристика
          .body-flex(v-show="tabView === 'characteristic'")
            container-table(
              :id="fields.id"
              :fields="fields"
              ref="containerTable"
              tabView="characteristic"
            )

          // ОТХОДЫ
          .body-flex(v-show="tabView === 'tab2'")
            garbage-table(
              :id="fields.id"
              ref="garbageTable"
              tabView="tab2"
              :fields="fields"
            )

          // Отходообразователи
          .body-flex(v-show="tabView === 'garbage-house'")
            garbage-house-container-table(
              :id="fields.id"
              ref="garbageHouseTable"
              tabView="garbage-house"
            )

          // ОБСЛУЖИВАНИЕ
          .body-flex(v-show="tabView === 'tab3'")
            service-table(
              :id="fields.id"
              ref="serviceTable"
              tabView="tab3"
            )

          // Журнал изменений
          .body-flex(v-show="tabView === 'tab4'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )

          // Документы
          .body-flex(v-show="tabView === 'tab5'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
import { core, msn } from '@/api/api-endpoints'
import hasMixin from '@/mixins/has-mixin'

import msnForm from './mixins/msn-form'
import ownerMixin from '@/mixins/owner-mixin'
import GarbageTable from '../msn/components/garbage-table'
import ServiceTable from './components/service-table'
import ContainerTable from './components/container-table'
import GarbageHouseContainerTable from './components/garbage-house-container-table'

export default {
  components: {
    GarbageHouseContainerTable,
    ContainerTable,
    ServiceTable,
    GarbageTable,
  },
  mixins: [msnForm, ownerMixin, hasMixin],
  data() {
    return {
      tabView: 'tab1',
      fields: {
        name: '',
        status_id: '',
        latitude: '',
        longitude: '',
        msn_type_code: '',
        msn_type_id: this.$route.meta.restApiOrder || 1,
        is_separate: 0,
        wasteoutLast: {},
        status_msn_id: null,
        wasteout_id: '',
        epidemiological_conclusion: '',
        route_period_id: 1,
        owner_id: null,
        owner_obj: {
          id: null,
          org_full_name: null,
        },
      },
      errors: null,
      dadata: {},
    }
  },
  computed: {
    moduleId() {
      return this.moduleIds['msn']
    },
    tabs() {
      const tabs = [{ tab1: 'Общие сведения' }]
      if (this.hasMsnGarbages) {
        tabs.push({ tab2: 'Отходы' })
      }
      tabs.push(
        { characteristic: 'Характеристика' },
        { 'garbage-house': 'Отходообразователи' }
      )
      if (this.hasMsnService) {
        tabs.push({ tab3: 'Обслуживание' })
      }
      if (this.fields.id && this.hasChangeLog) {
        tabs.push({ tab4: 'Журнал изменений' })
      }
      if (this.hasOrganizationDocuments) {
        tabs.push({ tab5: 'Документы' })
      }
      return tabs
    },
    collections() {
      return (
        this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      )
    },
    routePeriods() {
      return this.collections.route_period
    },
  },
  methods: {
    update() {
      msnForm.methods.update.call(this)
      if (this.item) {
        if (!this.item.wasteoutLast) {
          this.fields.wasteoutLast = {}
        }
      }
    },
    getContainersEndpoint(route) {
      if (route && route.params.id) {
        return msn.containersTable(route.params.id, {
          query: {
            type: 'tko',
          },
        })
      }
      return null
    },
    getContainersSeparateEndpoint(route) {
      if (route && route.params.id) {
        return msn.containersTable(route.params.id, {
          query: {
            type: 'separate_collection',
          },
        })
      }
      return null
    },
    getCollectionEndpoint() {
      return core.collection(
        'route_period,msn_container_roof,msn_container_floor,msn_container_fence,status,msn_by_type,status_msn',
        { query: { type: 'msn' } }
      )
    },
    getWasteoutEndpoint() {
      return core.statuses({ fields: 'wasteout' })
    },
    getDeleteUrl(id) {
      return msn.containerDelete(id)
    },
    getUpdateOrCreateUrl() {
      return msn.containerUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return msn.container(route.params.id)
    },
  },
  mounted() {
    this.fields.msn_type_code = this.$route.meta.name
    if (this.fields.route_period?.id) {
      this.fields.route_period_id = this.fields.route_period.id
    }
  },
}
</script>
<style lang="scss">
.period-label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.29;
  text-align: left;
  color: #72767a;
  font-family: 'SFUIText-Semibold';
}

.radio-block {
  label + label {
    margin-top: 10px;
  }

  label {
    display: block;
  }
}
</style>
